import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { getStoredUser } from '../../utilities/authentication';
import {
  DENTIST_BLOCKED_PATH_PREFIXES,
  isDentistUser,
  isSubAccountBlockedPath,
  isSubClientAccount,
  SUB_ACCOUNT_HOME_PATH,
} from '../../utilities/dentistPortal';

/**
 * Redirects dentist users away from vendor catalog routes (clients, colors, etc.).
 * Sub accounts are orders-only: redirected away from dashboard/invoices/settings.
 */
const DentistPortalGuard = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const user = getStoredUser();
    if (!isDentistUser(user)) {
      return;
    }

    const path = location.pathname.replace(/\/$/, '').toLowerCase() || '/';

    if (isSubClientAccount(user) && isSubAccountBlockedPath(path)) {
      navigate(SUB_ACCOUNT_HOME_PATH, { replace: true });
      return;
    }

    const blocked = DENTIST_BLOCKED_PATH_PREFIXES.some((prefix) =>
      path === prefix || path.startsWith(`${prefix}/`)
    );

    if (blocked) {
      const target = isSubClientAccount(user)
        ? SUB_ACCOUNT_HOME_PATH
        : (path === '/transactions' || path.startsWith('/transactions/')
          ? '/client-transactions'
          : '/client-settings');
      navigate(target, { replace: true });
    }
  }, [location.pathname, navigate]);

  return null;
};

export default DentistPortalGuard;
